module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmTitlea"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("I would like to gratefully thank all the people who have helped and encouraged me.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Firstly, without the bullying of Graham Simons and the backing up of his wife, Anne this book would not be here. I also wish to thank Laura Hirst and all at Pen & Sword for their faith and patience!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Captain Leslie Gosling, BOAC started everything off by suggesting I became a flying instructor and my instructor husband, Eric Pope, agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Captain ‘Jock’ Hunter with the Civil Aviation Flying Unit became my mentor, his kind wife, Betty putting me together again when necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Despite prejudice, Captain Charles Argles of Morton Air Services enabled me to become a commercial pilot - he said it was because I was mad enough to go on their night paper flights!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("However, it was Captain Bob Atkins who having accepted me as a pilot with Dan-Air, enabled me to become a jet captain.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Advice and encouragement for the writing of this book came from Captain Arthur Larkman and his wife Joy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Captain Keith Moody was indeed kind enough to write the forward, having read the manuscript while on holiday! He and his wife Barrie kept my spirits up all the way, also giving sound advice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I am very grateful for the interest of all my friends, including Rosemary and Derek Joyce, ex Air Traffic Controllers who have checked through my manuscript and have never ceased to encourage me. Other friends Berry Hudson and Maureen Sterling have helped with photocopying and my grandson Lewis Pope with scanning to make sure. I cannot thank my daughter-in-law Barbara Pope enough for transcribing my manuscript on to her computer in order to make it acceptable and for doing much behind the scenes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I cannot thank everyone individually, but hope that they will all feel it was worthwhile - the support and understanding of my own family being the most important.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Finally, special thanks to my son Jon for his practical help and my grand-daughter Samantha for her assistance.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-424fac1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_acknowledgements.vue
// module id = 66
// module chunks = 0